<template>
	<div id="app" >
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		name: 'App',
		components:{
		},
	}
</script>

<style>
	body {
		margin: 0;
		padding: 0;
		border: 0
	}

	/* 手机端全局适配：MessageBox 确认框 / Message 提示条挂在 body 上，需全局样式 */
	@media screen and (max-width: 640px) {
		.el-message-box {
			width: 86% !important;
			max-width: 86vw;
		}
		.el-message-box__message {
			font-size: 14px;
			line-height: 1.6;
		}
		.el-message-box__btns .el-button {
			padding: 10px 18px;
			font-size: 14px;
		}
		.el-message {
			max-width: 88vw;
			min-width: auto;
		}
	}
</style>
